import { NotificationInterface } from 'client/Interfaces/notifications/NotificationsInterface'

interface iNotificationRoute {
  // The route to navigate to, or the redirect path when the modal closes
  route: string
  // Which modal to open. Leave off if none.
  modal?: string
}

export const getNotificationRoute = (notification: NotificationInterface): iNotificationRoute => {
  switch (notification.type) {
    case 'bank.connection.expired':
      return { route: 'banking', modal: 'ConnectBankModal' }
    case 'delivery.creditnote.email.failure.email':
      return { route: `/reactInvoiceList/creditNote/${notification.data?.creditNoteId}` }
    case 'delivery.creditnote.email.sent':
      return { route: `/reactInvoiceList/creditNote/${notification.data?.creditNoteId}` }
    case 'delivery.estimate.email.failure.email':
      return { route: `/reactEstimateList/estimate/${notification.data?.estimateId}` }
    case 'delivery.estimate.email.sent':
      return { route: `/reactEstimateList/estimate/${notification.data?.estimateId}` }
    case 'delivery.invoice.email.sent':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'delivery.receipt.email.failure.email':
      return { route: `/receipts/approved/${notification.data?.receiptId}` }
    case 'delivery.receipt.email.sent':
      return { route: `/receipts/approved/${notification.data?.receiptId}` }
    case 'delivery.recipient-portal.opened':
      return { route: `/reactEstimateList/estimate/${notification.data?.estimateId}` }
    case 'document.accepted':
      return { route: `/reactEstimateList/estimate/${notification.data?.estimateId}` }
    case 'document.rejected':
      return { route: `/reactEstimateList/estimate/${notification.data?.estimateId}` }
    case 'document.reminder.email.notsent':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'document.reminder.email.sent':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'email.estimate.delivery.fail':
      return { route: `/reactEstimateList/estimate/${notification.data?.estimateId}` }
    case 'email.invoice.delivery.fail':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'invoice.paid':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'invoice.paynow.paid':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'invoice.tink.paid':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'recurringscheduler.created.sent':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'recurringscheduler.send.fail.head':
      return { route: `/reactInvoiceList/invoice/${notification.data?.invoiceId}` }
    case 'subscription.expired':
      return { route: 'myAccount/myPlan', modal: 'PremiumPlanModal' }
    case 'subscription.payment.failed':
      return { route: 'myAccount/myPlan', modal: 'PremiumPlanModal' }
    case 'subscription.initial.was.paid':
      return { route: '/myAccount/myPlan' }
    case 'subscription.resubscription.was.paid':
      return { route: '/myAccount/myPlan' }
    case 'subscription.will.expire':
      return { route: 'myAccount/myPlan', modal: 'PremiumPlanModal' }
    default:
      return { route: 'Route not yet implemented' }
  }
}
